<script>
// @vuese
// Komponent wyświetlający błędy i ostrzeżenia z modelu
export default {
  name: 'WError',
  props: {
    // Model ze schemy
    model: { type: Object, required: true },
    // Identyfikator spana z errorem
    errId: { type: String, required: false, default: 'err_' + Math.round(Math.random() * 1000000) }
  },
  methods: {
    // @vuese
    // Renderuje błąd
    renderError(createElement, text, cssClass) {
      return createElement('div', {}, [
        createElement('span', { attrs: { role: 'alert', id: this.errId }, class: 'text-sm ' + cssClass }, text)
      ]);
    }
  },
  render(createElement, context) {
    const error = this.model.$error;

    if (error) {
      return this.renderError(createElement, error, 'text-danger');
    }

    const warnings = this.model.$warnings;

    if (warnings.length) {
      return this.renderError(createElement, warnings[0], 'text-warning');
    }

    return createElement('div', {}, []);
  }
};
</script>
